<template>
    <div v-if="showPreorderInfo" class="pre-order">
        <div class="pick-up-time">
            <span v-if="!isFulfillmentTimeModeEqualTime && !isFulfillmentTimeModeEqualDeliveryTime"
                >{{ trans.orderReceivedPopover.plannedPickUpTime }}:
            </span>
            <span v-if="isFulfillmentTimeModeEqualDeliveryTime"
                >{{ trans.orderReceivedPopover.plannedDeliveryTime }}:
            </span>
            <strong>{{ pickupTime }}</strong>
        </div>
    </div>
</template>

<script setup lang="ts">
    import { trans } from "@/app/localization/Trans";
    import { DateTimeUtils } from "@/app/util/DateTimeUtils";
    import { SchedulingMode } from "@/data/model/Enums";
    import type { IOrderApplication } from "@/data/model/OrderApplication";
    import { computed } from "vue";

    const props = defineProps<{
        orderPickUpDateTime: Date | undefined;
        useCase: IOrderApplication | undefined;
    }>();

    const schedulingMode = computed(() => props.useCase?.schedulingMode);
    const showPreorderInfo = computed(() => {
        return (
            schedulingMode.value != null &&
            schedulingMode.value != SchedulingMode.None &&
            props.orderPickUpDateTime != null
        );
    });
    const isFulfillmentTimeModeEqualTime = computed(() => schedulingMode.value == SchedulingMode.Time);
    const isFulfillmentTimeModeEqualDeliveryTime = computed(() => schedulingMode.value == SchedulingMode.DeliveryTime);
    const showCirca = computed(() => !isFulfillmentTimeModeEqualTime.value);
    const pickupTime = computed(() =>
        showPreorderInfo.value != null
            ? DateTimeUtils.toDateTimeWithDayOfWeekAndCirca(props.orderPickUpDateTime!, showCirca.value)
            : ""
    );
</script>

<style lang="scss">
    .order-received-popover-content .pre-order {
        margin-top: 6px;

        .pick-up-time {
            text-align: center;
            font-size: 14px;
        }
    }
</style>
